import type {
  ClientContactTag,
  SupplierContactTag,
  IClientContact,
  ISupplierContact,
  IGenericContact,
} from '@bb/contacts';
import type { IGenericUser } from '@bb/users';
import type { TeamDoc } from '@bb/domain/dist/schemas';
import type { JsonObject } from '@/app-package';
import type { PopulatedUser } from '../../api/UserController/getProfile';

export enum ContactDrawerType {
  User = 'user',
  Team = 'team',
  Contact = 'contact',
  Coop = 'coop',
}

export enum ContactDrawerMode {
  Profile = 'profile',
  Edit = 'edit',
  Add = 'add',
}

export interface ContactMatchParams {
  id?: string;
}

export type ContactDrawerTeam = JsonObject<TeamDoc & { users: IGenericUser[] }>;

export type ContactDrawerUser = IGenericContact | PopulatedUser;

export const isUser = (contact: ContactDrawerUser): contact is PopulatedUser =>
  'org' in contact;

export const isContact = (
  contact?: ContactDrawerUser,
): contact is IClientContact | ISupplierContact =>
  contact && 'type' in contact && ['client', 'supplier'].includes(contact.type);

export const isClient = (
  contact: IClientContact | ISupplierContact,
): contact is IClientContact => contact.type === 'client';

export const isSupplier = (
  contact: IClientContact | ISupplierContact,
): contact is ISupplierContact => contact.type === 'supplier';

export type ContactTag = ClientContactTag | SupplierContactTag;
